export const REPORT_FILTER_ITEM_IN_SEPARATOR = ',';
export const REPORT_FILTER_ITEM_BETWEEN_SEPARATOR = '#_DELIMITER_#';